import React, { useEffect, useReducer, useState } from 'react';
import { Container, Row, Button, Nav, Accordion } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Subscribe from "./Subscribe"
import $ from "jquery"

const Apartments = () => {
    const [Notify, SetNotify] = useState("")
    const SubscribeFunction = () => {
        var name = document.getElementById("fullnamenewsletter").value
        var email = document.getElementById("newsletteremail2").value
        console.log(name)
        console.log(email)
        if (name === "") {
            SetNotify("Input your name")
        }

        else if (email === "") {
            SetNotify("Input your email")
        }

        else {
            var settingsone = {
                beforeSend: function () {
                    SetNotify("Subscribing...")
                },
                "url": "https://vast-bastion-98389.herokuapp.com/https://accounts.zoho.com/oauth/v2/token?refresh_token=1000.7e5557a26c308db2baae36c42c2cf4f3.2b156822d3e41c6e3d6f124374942133&client_id=1000.E7OTJTJ41R7DFO8E5011SHAWXQY4ZZ&client_secret=26b56a2da58cb14f1a55fc9a3931689764ccb3a25a&grant_type=refresh_token",
                "method": "POST",
                "timeout": 0,
            }

            $.ajax(settingsone).done(function (responseone) {
                console.log(responseone)
                console.log(responseone.access_token)

                var settingstwo = {
                    beforeSend: function () {
                        SetNotify("Processing...")
                    },
                    "url": "https://api.rich-oak.com/api/generic_links",
                    "method": "POST",
                    "timeout": 0,
                    //    "headers": { "Authorization": `Zoho-oauthtoken ${responseone.access_token}`},
                    "data":
                    {
                        "first_name": name,
                        "contact_email": email,
                        "authorization": `Zoho-oauthtoken ${responseone.access_token}`

                    },
                }

                $.ajax(settingstwo).done(function (responsetwo) {
                    console.log(responsetwo)
                    SetNotify(`A confirmation email has been sent to ${email}.`)

                })
                //   localStorage.setItem("userpin", responsetwo.pin_confirmation_url );



            })


        }

    }

    useEffect(() => {
        document.title = "Earth VIII Apartments"
    }, [])

    const [RotateDg, setRotateDg] = useState()

    const rotateDgCSS = {
        transform: "rotate(-25deg)",
        transition: "transform 0.2s ease 0s"
    }

    const removerotateDgCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.2s ease 0s"
    }

    const rotatedg = () => {
        setRotateDg(rotateDgCSS)
    }
    const stoprotatedg = () => {
        setRotateDg(removerotateDgCSS)
    }



    return (

        <div>
            <div className="homepageslider" id="homepageslider">
                <Header />

                <div class="apartmentsfirstbox">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <h1 className="homesherotitle">Even short stays should <br />
                                    be worth <span className="makeyellow">  remembering</span>
                                </h1>
                                <p className="apartmentsherosubtitle fordesktoponly">
                                    Earth VII Apartments are unique for its intentional interior designs which we modelled after beautiful cities in the world - infusing both the design aesthetics and cultural feeling
                                </p>

                                <p className="apartmentsherosubtitle formobileonly">
                                    Earth VII Apartments are unique for its intentional interior designs which we modelled after beautiful cities in the world - infusing both the design aesthetics and cultural feeling
                                </p>


                                <p className="homesheroctabuttonp" >
                                    <div class="col-sm-12 ">
                                        <div class="single2">
                                            <div class="input-group">
                                                <input type="email" class="form-control subscribehome2" placeholder="Enter email Address" id="newsletteremail" />
                                                <span class="input-group-btn">
                                                    <button class="btn btn-theme" type="submit" onclick="newsFunction()">Submit</button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <Nav.Link className="homesheroctabutton "  href="/signup"><button className="hmfirstboxbutton3">Explore apartments</button></Nav.Link> */}
                                    {/* <Nav.Link className="homesheroctabutton  homesctabutton2"  href="/homes"><p>Contact us  <img className="" src="images/diagonalarrow.png"/></p></Nav.Link> */}
                                </p>
                            </div>

                            <div class="col-md-6">
                                <img className="img-fluid" src="images/earthviiapartments.png" />
                            </div>

                        </div>
                    </div>
                </div>




                <div className='apartmentssecondbox'>
                    <div className='container'>
                        <div class="row">
                            <div class="col-md-5">
                                <img className="img-fluid hmsecondbox2" src="images/apartmentsbooking.png" />


                            </div>


                            <div class="col-md-1"></div>


                            <div class="col-md-6">
                                <div class="row mobilerow">
                                    <div class="col-md-1 col-2">
                                        <h2 className="line hmsecondboxtitle"></h2>

                                    </div>
                                    <div class="col-md-11 col-10">
                                        <h2 className=" hmsecondboxtitle fordesktoponly">  We have made booking<br /> as simple as possible</h2>
                                        <h2 className=" hmsecondboxtitle formobileonly">  We have made booking as simple as possible</h2>

                                    </div>


                                </div>
                                <div class="row">

                                    <div class="col-md-4 col-4 apartmentsstepsbox3">
                                        <img src="/images/icons/choose.png" />
                                        <p className="apartmentssteps">Choose an <br /> apartment</p>
                                    </div>

                                    <div class="col-md-4 col-4 apartmentsstepsbox3">
                                        <img src="/images/icons/confirm.png" />
                                        <p className="apartmentssteps">Confirm <br /> availability</p>
                                    </div>

                                    <div class="col-md-4 col-4 apartmentsstepsbox3">
                                        <img src="/images/icons/payment.png" />
                                        <p className="apartmentssteps">Make your <br /> payment</p>
                                    </div>

                                    <p className="homesheroctabuttonp" >
                                        <Nav.Link className="homesheroctabutton apartmentshomesheroctabutton3" target="_blank" href=""><button className="hmfirstboxbutton3">Book your stay</button></Nav.Link>
                                    </p>
                                </div>






                            </div>
                        </div>
                    </div>
                </div>













                <div class="col-md-12">
                    <h1 className="apartmentssecondboxtitle">Our Apartments</h1>
                </div>

                <div className='homessecondbox'>
                    <div className='container'>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="row">
                                    <div class="col-md-1 col-2">
                                        <h2 className="line hmsecondboxtitle"></h2>

                                    </div>
                                    <div class="col-md-11 col-10">
                                        <h2 className="stepdown hmsecondboxtitle"> New York</h2>
                                        {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                                    </div>


                                </div>
                                <img className="img-fluid hmsecondbox2 formobileonly" src="images/newyork.png" />

                                <p className="hmseconddescription">
                                    This 2 bedroom apartment located at Wuse 2 is modeled after the beautiful New York city in the United States. Decorated with a touch of elegance and sophistication that New York is known for .

                                </p>

                                <div class="row">
                                    <div class="col-md-6">
                                        <h5 style={{ paddingTop: "10px", paddingBottom: "10px" }} className='hmsecondboxtitlefeature'>Paid services</h5>

                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Gym services</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Best restaurants</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Networking events</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Movies and events</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Spa Services</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Car services</p>
                                        {/* <p className="hmseconddescription"><img className="img-fluid" src="images/icons/check.png"/> House keeping/laundry services</p> */}


                                    </div>
                                    <div class="col-md-6">


                                        <h5 style={{ paddingTop: "10px", paddingBottom: "10px" }} className='hmsecondboxtitlefeature'>Apartment features</h5>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Unlimited Wifi Access</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Complimentary breakfast</p>


                                    </div>
                                </div>




                                <a className="linkdecoration" target="_blank" href="http://shortlets.earthvii.xyz">  <p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg} className="apartmentslearnmorecta3">View apartment <img className="" style={RotateDg} src="images/rightarrow.png" /></p></a>

                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-6">

                                {/* <div class="row">
                   <div class="col-md-6">
                   <img className="img-fluid" src="images/icons/check.png"/> 
                   </div>
                   <div class="col-md-6">

                   </div>
               </div> */}


                                <img className="img-fluid fordesktoponly" src="images/newyork.png" />
                            </div>
                        </div>
                        <div className='fordesktoponly'>
                            <p style={{ marginTop: "150px" }}></p>
                        </div>

                        <hr className='vohlm' />


                    </div>


                </div>


                <div className='fordesktoponly'>
                    <p style={{ marginTop: "150px" }}></p>
                </div>
                <div className='homessecondbox aptssecondbox'>
                    <div className='container'>
                        <div class="row">
                            <div class="col-md-5">
                                <div class="row">
                                    <div class="col-md-1 col-2">
                                        <h2 className="line hmsecondboxtitle"></h2>

                                    </div>
                                    <div class="col-md-11 col-10">
                                        <h2 className="stepdown hmsecondboxtitle"> Istanbul</h2>
                                        {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                                    </div>


                                </div>
                                <img className="img-fluid hmsecondbox2 formobileonly" src="images/instabul.png" />

                                <p className="hmseconddescription">
                                    This 2 bedroom apartment located at Wuse 2 is modeled after the beautiful city of St. Pietersburg in Russia. Decorated with a touch of traditional Russian designs and modern amenities.
                                    This Apartment is located at Wuse 2
                                </p>

                                <div class="row">
                                    <div class="col-md-6">
                                        <h5 style={{ paddingTop: "10px", paddingBottom: "10px" }} className='hmsecondboxtitlefeature hmsecondboxtitlefeaturesmallerscreen'>Paid services</h5>

                                        <p className="hmseconddescription  hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Gym services</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Best restaurants</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Networking events</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Movies and events</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Spa Services</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Car services</p>
                                        {/* <p className="hmseconddescription"><img className="img-fluid" src="images/icons/check.png"/> House keeping/laundry services</p> */}


                                    </div>
                                    <div class="col-md-6">


                                        <h5 style={{ paddingTop: "10px", paddingBottom: "10px" }} className='hmsecondboxtitlefeature  hmsecondboxtitlefeaturesmallerscreen'>Apartment features</h5>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Unlimited Wifi Access</p>
                                        <p className="hmseconddescription hmseconddescriptionsmscreen"><img className="img-fluid" src="images/icons/check.png" /> Complimentary breakfast</p>


                                    </div>
                                </div>





                                <a className="linkdecoration" target="_blank" href="http://shortlets.earthvii.xyz">  <p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg} className="apartmentslearnmorecta3">View apartment <img style={RotateDg} className="" src="images/rightarrow.png" /></p></a>

                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-6">

                                {/* <div class="row">
                   <div class="col-md-6">
                   <img className="img-fluid" src="images/icons/check.png"/> 
                   </div>
                   <div class="col-md-6">

                   </div>
               </div> */}


                                <img className="img-fluid fordesktoponly" src="images/instabul.png" />
                            </div>
                        </div>
                        {/* <hr className='vohlm'/> */}
                    </div>
                </div>

                <div className='fordesktoponly'>
                    <p style={{ marginTop: "170px" }}></p>
                </div>
                <div className='homessecondbox'>
                    <div className='container'>
                        <div class="row mobilerow">
                            <div class="col-md-6">
                                <img className="img-fluid" src="images/westrive.png" />


                            </div>



                            <div class="col-md-5">
                                <div class="row letusmobile">
                                    <div class="col-md-1 col-2 ">
                                        <h2 className="line hmsecondboxtitle"></h2>

                                    </div>
                                    <div class="col-md-11 col-10">
                                        <h2 className=" hmsecondboxtitle fordesktoponly">  We always strive to <br />raise the bar.</h2>
                                        <h2 className=" hmsecondboxtitle formobileonly">  We always strive to raise the bar.</h2>



                                    </div>

                                    <p className="hmseconddescription">
                                        Earth VII Apartments is unique for its intentional interior designs which we modelled after beautiful cities in the world - infusing both the design aesthetics and cultural feeling
                                    </p>


                                    <p className="hmseconddescription">

                                        Staying at any of our luxurious apartments will feel like living in a new city. With access to amenities such as: restaurants and car services. You can enjoy your stay and focus on your travel objectives while we take care of the rest.
                                    </p>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

                <div className='fordesktoponly'>
                    <p className='addspacing70'></p>
                </div>
                <Testimonials />
                <div className='fordesktoponly'>
                    <p className='addspacing70'></p>
                </div>

                <div className="apnewsletterbox">
                    <h4 className="apherotitle">Stay updated when we add a new city and be<br />
                        notified on <span className="makeyellow">  amazing discounts</span>
                    </h4>

                    <div class="row">
                        <div class="col-md-3">
                        </div>

                        <div class="col-md-6">
                            <div className="row aptsubinput">
                                <div class="col-md-6">
                                    <input type="text" class="form-control form-control-lg  hminput " id="fullnamenewsletter" placeholder="Enter Name" />

                                </div>


                                <div class="col-sm-6 aptemailinput">
                                    <div class="single">
                                        <div class="input-group">
                                            <input type="email" class="form-control subscribehome hminput" placeholder="Enter email Address" id="newsletteremail2" />
                                            <span class="input-group-btn">
                                                <button class="btn btn-theme" type="submit" onClick={SubscribeFunction}>Submit</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <p style={{ textAlign: "center", paddingTop: "20px", color: "#FFF", fontWeight: "bold" }}>{Notify}</p>
                                {/* <Nav.Link className="homesheroctabutton "  href="/signup"><button className="hmfirstboxbutton3">Explore apartments</button></Nav.Link> */}
                                {/* <Nav.Link className="homesheroctabutton  homesctabutton2"  href="/homes"><p>Contact us  <img className="" src="images/diagonalarrow.png"/></p></Nav.Link> */}

                            </div>

                        </div>

                        <div class="col-md-3">
                        </div>

                    </div>
                </div>
                <div className='fordesktoponly'>
                    <p className='addspacing70'></p>
                </div>

                <Faq />




                <div className='fordesktoponly'>
                    <p className='addspacing70'></p>
                </div>



                <div className='fordesktoponly'>
                    <p className='addspacing70'></p>
                </div>
                <div className='formobileonly'>
                    <p className='addspacing70'></p>
                </div>




                <Contact />








            </div>






            <Footer />
        </div>


    )


}


export { Apartments as default }